import React from "react";

const Facebook = () => {
    return (
        <svg fill="none" viewBox="0 0 20 19">
          <path fill="#fff" d="M19.09 9.34506c0-5.02077-4.0701-9.09091-9.09089-9.09091-5.02077 0-9.090907 4.07014-9.090907 9.09091 0 4.53744 3.324397 8.29844 7.670457 8.98044v-6.3526H6.27042V9.34506h2.30824V7.34222c0-2.27841 1.35724-3.53693 3.43374-3.53693.9943 0 2.035.17755 2.035.17755v2.23722h-1.1463c-1.1293 0-1.4815.70082-1.4815 1.42046v1.70454h2.5213l-.4031 2.62784h-2.1182v6.3526c4.346-.682 7.6704-4.443 7.6704-8.98044Z"/>
        </svg>
    );
}

export default Facebook;